import "$styles/index.css"

// --- Mobile navigation toggle -------------------------------------------
function initMobileNav() {
  const toggle = document.querySelector("[data-nav-toggle]")
  const menu = document.querySelector("[data-nav-menu]")
  if (!toggle || !menu) return

  const setOpen = (open) => {
    toggle.setAttribute("aria-expanded", String(open))
    menu.classList.toggle("hidden", !open)
  }

  toggle.addEventListener("click", () => {
    const open = toggle.getAttribute("aria-expanded") === "true"
    setOpen(!open)
  })

  // Close on Escape and return focus to the toggle.
  menu.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      setOpen(false)
      toggle.focus()
    }
  })
}

// --- Scroll reveal (respects prefers-reduced-motion) --------------------
function initReveal() {
  const els = document.querySelectorAll(".reveal")
  if (!els.length) return

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  if (reduce || !("IntersectionObserver" in window)) {
    els.forEach((el) => el.classList.add("is-visible"))
    return
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible")
          observer.unobserve(entry.target)
        }
      })
    },
    { rootMargin: "0px 0px -10% 0px", threshold: 0.05 }
  )
  els.forEach((el) => observer.observe(el))
}

document.addEventListener("DOMContentLoaded", () => {
  initMobileNav()
  initReveal()
})
